import React from 'react';

import { Interval } from 'luxon';

import TimelineWidget from './TimelineWidget.js';
import TabWidget from './TabWidget.js';
import TemporalWidget from './TemporalWidget.js';
import FilterWidget from './FilterWidget.js';
import EnvironmentWidget from './EnvironmentWidget.js';
import ShareWidget from './ShareWidget.js';
import {randomChoice} from './utils.js';

import './ControlWidget.css';

class ControlWidget extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            'tab_selected': 'Temporal',
            'gif_quality': 'Medium',
        };

        this.changeTab = this.changeTab.bind(this);

        const temp_examples = {
            'April 26, 1991': ['state = Kansas', 'path-length > 20'],
            'Apr 11 1965': ['state = Ohio', 'path-length >= 50'],
            '4/27/2011': ['state = MS', 'path-length >= 50', 'fatalities > 20'],
            '5/3/99': ['state = OK', 'injuries > 10'],
            'May 4-11 2003': ['state = Illinois', 'path-width < 400'],
            'Jun 16-18, 2014': ['state = NE', 'path-width >= 400'],
            '1974': ['region = southeast', 'injuries > 20'],
            '1957': ['region = plains', 'fatalities >= 10'],
            'May 2019': ['region = midwest', 'path-length < 3'],
            'Nov 2013': ['state = IN', 'injuries >= 10']
        };


        this.temp_example = randomChoice(Object.keys(temp_examples));

        const filt_examples = temp_examples[this.temp_example];
        this.filt_example = randomChoice(filt_examples);
    }

    changeTab(new_tab) {
        this.setState({'tab_selected': new_tab});
    }

    render() {
        const margin_left = this.props['timeline_margins']['left'];
        const margin_right = this.props['timeline_margins']['right'];
        const timeline_width = this.props['window_size']['width'];
        const data_limits = Interval.fromDateTimes(this.props['data_limits'].start.plus(this.props['cday_offset']), 
                                                   this.props['data_limits'].end.plus(this.props['cday_offset']));

        const tabs = [
            {'name': 'Temporal', 'enabled': true, 'jsx':
                <TemporalWidget
                    interval={this.props['interval']}
                    example={this.temp_example}
                    onintervalchange={this.props['onintervalchange']}
                    data_limits={data_limits}
                    cday_offset={this.props['cday_offset']}
                    window_size={this.props['window_size']}
                    random_day_func={this.props['random_day_func']}
                    env_intv_dur_cutoff={this.props['env_intv_dur_cutoff']}
                    temp_display={this.props['temp_display']}
                    ontempdisplaychange={this.props['ontempdisplaychange']}
                    allow_random_day={this.props['domain_has_env_data']}
                />
            },
            {'name': 'Filters', 'enabled': true, 'jsx':
                <FilterWidget
                    width={this.props['window_size']['width']}
                    example={this.filt_example}
                    filters={this.props['filters']}
                    domains={this.props['domains']}
                    sel_domain={this.props['sel_domain']}
                    units={this.props['units']}
                    allow_states={this.props['domain_has_states']}

                    onpartselectchange={this.props['onpartselectchange']}
                    onfilterchange={this.props['onfilterchange']}
                    ondomainchange={this.props['ondomainchange']}
                />
            },
            {'name': 'Environment', 'enabled': true, 'jsx':
                <EnvironmentWidget
                    interval={this.props['interval']}
                    timeline_taxis={this.props['timeline_taxis']}
                    is_animating={this.props['is_animating']}
                    cday_offset={this.props['cday_offset']}
                    left={margin_left}
                    right={timeline_width - margin_right}

                    sel_data_time={this.props['sel_data_time']}
                    env_data_times={this.props['env_data_times']}
                    env_handler={this.props['env_handler']}
                    env_type={this.props['env_type']}
                    env_intv_dur_cutoff={this.props['env_intv_dur_cutoff']}

                    sel_domain={this.props['sel_domain']}
                    
                    onenvlayerchange={this.props['onenvlayerchange']}
                    onenvtimechange={this.props['onenvtimechange']}
                    onanimtoggle={this.props['onanimtoggle']}
                    onanimspeedchange={this.props['onanimspeedchange']}
                />
            },
            {'name': 'Share', 'enabled': true, 'jsx':
                <ShareWidget
                    gif_disabled={this.props['env_data_times'].length == 0}
                    gif_quality={this.state['gif_quality']}
                    onscreenshot={this.props['onscreenshot']}
                    oncreategif={this.props['oncreategif']}
                    onchangegifquality={qual => this.setState({'gif_quality': qual})}
                />
            }
        ];

        const show_env_markers = this.state['tab_selected'] == 'Environment';

        return (    
            <div id='controls' className={this.props['visible'] ? '' : 'hidden'}>
                <TabWidget
                    visible={this.props['visible']}
                    width={timeline_width}
                    tabs={tabs.map(t => {return {'name': t['name'], 'enabled': t['enabled']};})}
                    selected={this.state['tab_selected']}
                    ontabchange={this.changeTab}
                    onshowhidecontrols={this.props['onshowhidecontrols']}
                />
                <div id='control-container'>
                    {tabs.filter(t => t['name'] == this.state['tab_selected'])[0]['jsx']}
                </div>
                <TimelineWidget 
                    interval={this.props['interval']}
                    tor_coll={this.props['tor_coll']}
                    partitioner={this.props['partitioner']}
                    part_select={this.props['part_select']}
                    
                    width={timeline_width}
                    height={150}
                    margins={this.props['timeline_margins']}
                    taxis={this.props['timeline_taxis']}
                    cday_offset={this.props['cday_offset']}
                    data_limits={data_limits}

                    show_env_markers={show_env_markers}
                    env_handler={this.props['env_handler']}

                    onintervalchange={this.props['onintervalchange']}
                    ontboundschange={this.props['ontboundschange']}

                    setscreenshotfunc={this.props['setscreenshotfunc']}
                />
            </div>
        );
    }
}

export default ControlWidget;
